import React, { Component } from 'react'
import styled from 'styled-components';
import sortDesc from '../../../assets/images/icon/sort-desc.svg';

class SortButton extends Component {
  render() {
    const { text, onClick, isActive, ...rest } = this.props;
    return (
      <Button
        onClick={(event) => onClick(event)}
        isActive={isActive}
        {...rest}
      >
        <div {...rest}/>
        {text}
      </Button>
    );
  }
}

const Button = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  height: 24px;
  padding: 0 10px;
  font-size: 12px;
  border-radius: 5px;
  border: 1px solid var(--secondary-500);

  & > div {
    width: 16px;
    height: 16px;
    mask-image: url(${sortDesc});
    mask-size: 16px 16px;
    mask-repeat: no-repeat;
    background-color: var(--secondary-500);
  }

  ${({ isActive }) => isActive ? `
    background-color: var(--secondary-500);
    color: var(--white);

    & > div {
      background-color: var(--white);
    }
  ` : `
    background-color: var(--white);
    color: var(--secondary-500);
  `}

  &:hover {
    background-color: var(--secondary-500);
    color: var(--white);

    & > div {
      background-color: var(--white);
    }
  }
`;

export default SortButton;